'use client'

import { FixedBanner } from '@circlefin/components'
import useTranslation from 'next-translate/useTranslation'

/**
 * Props for the MaintenanceMode component.
 */
export interface MaintenanceModeProps {
  /**
   * Specifies whether the faucet is currently in maintenance mode.
   */
  enabled: boolean
}

/**
 * Displays a fixed banner to indicate that the faucet is in maintenance mode.
 * @returns The maintenance mode banner, or null if the faucet is not in maintenance mode.
 */
export const MaintenanceMode: React.FC<MaintenanceModeProps> = ({
  enabled,
}) => {
  // Use the useTranslation hook to get the translation function
  const { t } = useTranslation('faucet')

  // Render the maintenance mode banner if the faucet is in maintenance mode
  return enabled ? (
    <FixedBanner className="mb-4" status="info">
      <FixedBanner.Title>{t`requestTokenForm.maintenanceMode.title`}</FixedBanner.Title>
      <FixedBanner.Description>
        {t`requestTokenForm.maintenanceMode.description`}
      </FixedBanner.Description>
    </FixedBanner>
  ) : null
}
